// Structured data — replicated exactly from the delivered index.html source of truth.
export const clinicSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  "@id": "https://www.cesma.com.mx/#clinica",
  name: "CESMA — Clínica Especialista en Salud Mental y Adicciones",
  legalName: "Salud Integral Alas Enlazadas A.C.",
  url: "https://www.cesma.com.mx/",
  logo: "https://www.cesma.com.mx/assets/logo.png",
  image: "https://www.cesma.com.mx/assets/jardin.webp",
  description:
    "CESMA es una clínica especialista en salud mental y adicciones ubicada en Cuernavaca, Morelos, México. Ofrece tratamiento residencial interdisciplinario y confidencial para adicciones, salud mental y patología dual, con más de 27 años de experiencia y sucursales separadas para hombres y mujeres.",
  telephone: "+52-777-555-7088",
  email: "contactocesma@gmail.com",
  foundingDate: "1998",
  priceRange: "$$",
  medicalSpecialty: ["Psychiatric", "Addiction Medicine"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Lisboa 9, Col. Burgos",
    addressLocality: "Cuernavaca",
    addressRegion: "Morelos",
    postalCode: "62580",
    addressCountry: "MX",
  },
  areaServed: [
    { "@type": "City", name: "Cuernavaca" },
    { "@type": "State", name: "Morelos" },
    { "@type": "Country", name: "México" },
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  availableService: [
    { "@type": "MedicalTherapy", name: "Tratamiento de adicciones" },
    { "@type": "MedicalTherapy", name: "Atención en salud mental" },
    { "@type": "MedicalTherapy", name: "Tratamiento de patología dual" },
    { "@type": "MedicalTherapy", name: "Terapia familiar" },
  ],
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "¿Cuánto dura el tratamiento en CESMA?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "CESMA cuenta con dos planes residenciales, de 45 y 90 días. El plan se define en la valoración inicial según las necesidades de cada persona.",
      },
    },
    {
      "@type": "Question",
      name: "¿El paciente debe ingresar por voluntad propia?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Lo ideal es que sí. Sin embargo, muchas veces la persona está confundida o desgastada y no puede decidirlo con claridad. Por eso acompañamos a la familia y ofrecemos un servicio de intervención en crisis para abordar la situación de forma respetuosa.",
      },
    },
    {
      "@type": "Question",
      name: "¿Hay terapia para la familia?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sí. La familia es determinante en la recuperación. Ofrecemos terapias grupales sabatinas y terapia familiar individual para que el proceso avance en la misma dirección.",
      },
    },
    {
      "@type": "Question",
      name: "¿En CESMA hay maltrato hacia los pacientes?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "No. Nuestro modelo es completamente humanista y congruente con nuestros valores. El trato digno y respetuoso es la base de todo el tratamiento.",
      },
    },
    {
      "@type": "Question",
      name: "¿Dónde está ubicada la clínica CESMA?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "CESMA se ubica en Lisboa 9, Col. Burgos, Cuernavaca, Morelos, una de las zonas más tranquilas de la ciudad. Atención los 7 días de la semana. Teléfono y WhatsApp: 777 555 7088.",
      },
    },
  ],
};
